import $ from 'jquery'
import _ from 'lodash'

onDomLoad(function ($dom) {
  const $periodDocumentsList = $dom.find(
    "[data-behaviour='period-document-list']"
  )
  if ($periodDocumentsList.length === 0) return

  // Replace document
  $periodDocumentsList.on(
    'click',
    "[data-behaviour='period-document-replace']",
    (event) => {
      const $button = $(event.target)
      const documentId = $button.data('document-id')
      const maxSize = $button.data('max-size')

      window.modalCitizen.openDocumentSelectModal({
        firmId: Silverfin.currentFirmId,
        companyId: Silverfin.currentCompanyId,
        options: {
          type: 'replacement',
          fileCollectionValue: [],
          modalOpened: () => {},
          replace: (documentData) => {
            let attrs = {}

            switch (documentData.linkType) {
              case 'DirectUpload':
                attrs = {
                  document_direct_upload_path: documentData.link,
                }
                break
              case 'PermanentDocument':
                attrs = {
                  copy_from_permanent_document_id:
                    documentData.permanent_document_id,
                }
                break
              case 'Document':
                attrs = {
                  document_id: documentData.document_id,
                }
                break
            }

            if (maxSize) attrs.max_size = maxSize

            window.sfConfirm({
              question: I18n.t(
                'components.document.existing_docs_page.replace_file_title'
              ),
              message: I18n.t(
                'components.document.existing_docs_page.replace_file_warning'
              ),
              confirmLabel: I18n.t(
                'components.document.existing_docs_page.replace_btn'
              ),
              cancelLabel: I18n.t(
                'js.global_confirmation_modal.default.cancel'
              ),
              onConfirm: () => {
                Silverfin.Spinner.start()
                $.ajax({
                  url: Silverfin.Routes.replace_document_path(
                    Silverfin.currentFirmId,
                    Silverfin.currentCompanyId,
                    documentId
                  ),
                  type: 'post',
                  dataType: 'json',
                  data: {
                    document_attributes: attrs,
                  },
                  success: (success) => {
                    if (success) location.reload()
                  },
                })
              },
              options: {
                message_class: 'sf-alert-danger',
                confirm_class: 'sf-btn-danger',
              },
            })
          },
        },
      })
    }
  )

  // Delete document
  $periodDocumentsList.on(
    'click',
    "[data-behaviour='period-document-delete']",
    (event) => {
      const $target = $(event.currentTarget)

      window.sfConfirm({
        question: `${I18n.t(
          'js.global_confirmation_modal.default.delete'
        )} ${$target.data('document-name')}?`,
        message: I18n.t(
          'components.document.existing_docs_page.delete_file_warning'
        ),
        confirmLabel: I18n.t(
          'components.document.existing_docs_page.delete_confirm_label'
        ),
        cancelLabel: I18n.t('js.global_confirmation_modal.default.cancel'),
        onConfirm: () => {
          $(
            `a.period-document-remove-btn[data-document-id='${$target.data(
              'document-id'
            )}']`
          ).click()
        },
        options: {
          message_class: 'sf-alert-danger',
          confirm_class: 'sf-btn-danger',
        },
      })
    }
  )

  // To stop spamming our server
  let requestInProgress = false

  function fetchDocuments(params, successCallback) {
    if (requestInProgress) return

    requestInProgress = true

    const url = Silverfin.Routes.period_document_list_path(
      Silverfin.currentFirmId,
      Silverfin.currentCompanyId
    )
    $.get(url, params).done((data) => {
      requestInProgress = false
      successCallback(data)
    })
  }

  // Search documents
  const $searchInput = $dom.find("[data-behaviour='period-document-search']")
  $searchInput.on(
    'keyup',
    _.debounce((event) => {
      // Reset pagination
      $periodDocumentsList.data('page', 0)

      const $spinner = $('i.top-spinner').removeClass('sf-hidden')
      fetchDocuments({ q: event.target.value }, (data) => {
        $periodDocumentsList.html(data)
        $spinner.addClass('sf-hidden')
      })
    }, 300)
  )

  // Infinite scroll for documents
  if (bottomOfTheDocumentReached()) fetchNextBatchOfDocuments()

  window.addEventListener('scroll', scrollToBottomCallback)
  window.addEventListener('turbolinks:before-cache', function () {
    window.removeEventListener('scroll', scrollToBottomCallback)
  })
  window.addEventListener('turbolinks:before-render', function () {
    window.removeEventListener('scroll', scrollToBottomCallback)
  })

  function scrollToBottomCallback() {
    if (bottomOfTheDocumentReached()) {
      fetchNextBatchOfDocuments()
    }
  }

  function bottomOfTheDocumentReached() {
    const $window = $(window)
    return $(document).height() - $window.height() - 100 < $window.scrollTop()
  }

  function fetchNextBatchOfDocuments() {
    const currentPage = parseInt($periodDocumentsList.data('page'))
    const totalPages = parseInt($periodDocumentsList.data('page-count'))
    const newPage = currentPage + 1
    if (newPage >= totalPages) return

    const $spinner = $('i.bottom-spinner').removeClass('sf-hidden')
    fetchDocuments({ q: $searchInput.val(), p: newPage }, (data) => {
      // This check is needed along with the page-count check to avoid useless page loadings.
      // When user types search keywords, filtering can lead to fewer pages than the initial page-count
      if (!data || data.length === 0) {
        $periodDocumentsList.data('page', totalPages)
      } else {
        $periodDocumentsList.data('page', newPage)
        $periodDocumentsList.append(data)
      }
      $spinner.addClass('sf-hidden')
    })
  }
})
